import Constants from './constants'

export const loadUsers = (formData, callback) => {  
  return {
    type: Constants.LOAD_USERS,
    payload: formData,
    callback
  }
}

export const setUsers = (data) => {  
  return {
    type: Constants.SET_USERS,
    payload: data,
  }
}

export const loadActivityTypes = (formData, callback) => {  
  return {
    type: Constants.LOAD_ACTIVITYTYPES,
    payload: formData,
    callback
  }
}

export const updateStatusType = (formData, callback) => {  
  return {
    type: Constants.UPDATE_ACTIVITYTYPES,
    payload: formData,
    callback
  }
}

export const setActivityTypes = (data) => {  
  return {
    type: Constants.SET_ACTIVITYTYPES,
    payload: data,
  }
}

export const loadActivities = (formData, callback) => {  
  return {
    type: Constants.LOAD_ACTIVITIES,
    payload: formData,
    callback
  }
}

export const loadExcelActivities = (formData, callback) => {  
  return {
    type: Constants.LOAD_ACTIVITIES_XLS,
    payload: formData,
    callback
  }
}

export const removeLogs = (formData, callback) => {  
  return {
    type: Constants.REMOVE_ACTIVITIES,
    payload: formData,
    callback
  }
}

export const setActivities = (data) => {  
  return {
    type: Constants.SET_ACTIVITIES,
    payload: data,
  }
}

export const setExcelActivities = (data) => {  
  return {
    type: Constants.SET_ACTIVITIES_XLS,
    payload: data,
  }
}

export const setMessage = (data) => {  
  return {
    type: Constants.SET_MESSAGE,
    payload: data,
  }
}

export const setError = (data) => {  
  return {
    type: Constants.SET_ERROR,
    payload: data,
  }
}


export const setLoading = (flag) => {  
  return {
    type: Constants.SET_LOADING,
    payload: flag,
  }
}



// WEBPACK FOOTER //
// ./src/views/Admin/ActivityLog/actions.js